function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  id: "logoRail",
  d: "M132.518 77.6798C132.518 78.4129 132.281 79.0239 131.807 79.5126C131.342 79.993 130.627 80.2331 129.664 80.2331H128.077V83.9115H127V75.1011H129.664C130.596 75.1011 131.302 75.3413 131.784 75.8216C132.273 76.302 132.518 76.9213 132.518 77.6798ZM129.664 79.2851C130.264 79.2851 130.706 79.1461 130.99 78.868C131.274 78.5899 131.417 78.1938 131.417 77.6798C131.417 76.5927 130.832 76.0492 129.664 76.0492H128.077V79.2851H129.664Z",
  stroke: "#1F1A17",
  strokeWidth: 0.5
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  id: "logoRail",
  d: "M137.599 84C136.833 84 136.134 83.8104 135.503 83.4312C134.871 83.0435 134.37 82.5084 133.999 81.8258C133.636 81.1348 133.454 80.3596 133.454 79.5C133.454 78.6404 133.636 77.8694 133.999 77.1868C134.37 76.4958 134.871 75.9607 135.503 75.5815C136.134 75.1938 136.833 75 137.599 75C138.372 75 139.075 75.1938 139.706 75.5815C140.338 75.9607 140.835 76.4916 141.198 77.1742C141.561 77.8567 141.743 78.632 141.743 79.5C141.743 80.368 141.561 81.1433 141.198 81.8258C140.835 82.5084 140.338 83.0435 139.706 83.4312C139.075 83.8104 138.372 84 137.599 84ZM137.599 83.0014C138.175 83.0014 138.692 82.8581 139.15 82.5716C139.615 82.2851 139.978 81.8764 140.239 81.3455C140.507 80.8146 140.642 80.1994 140.642 79.5C140.642 78.7921 140.507 78.177 140.239 77.6545C139.978 77.1236 139.619 76.7149 139.161 76.4284C138.704 76.1419 138.183 75.9986 137.599 75.9986C137.014 75.9986 136.493 76.1419 136.036 76.4284C135.578 76.7149 135.215 77.1236 134.946 77.6545C134.686 78.177 134.555 78.7921 134.555 79.5C134.555 80.1994 134.686 80.8146 134.946 81.3455C135.215 81.8764 135.578 82.2851 136.036 82.5716C136.501 82.8581 137.022 83.0014 137.599 83.0014Z",
  stroke: "#1F1A17",
  strokeWidth: 0.5
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  id: "logoRail",
  d: "M153.538 75.1011L151.146 83.9115H149.938L148.02 76.8202L146.031 83.9115L144.835 83.9242L142.526 75.1011H143.674L145.474 82.5716L147.463 75.1011H148.671L150.566 82.5463L152.377 75.1011H153.538Z",
  stroke: "#1F1A17",
  strokeWidth: 0.5
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  id: "logoRail",
  d: "M155.794 76.0365V78.9817H158.802V79.9298H155.794V82.9635H159.157V83.9115H154.717V75.0885H159.157V76.0365H155.794Z",
  stroke: "#1F1A17",
  strokeWidth: 0.5
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  id: "logoRail",
  d: "M165.133 83.9115L163.167 80.309H161.865V83.9115H160.787V75.1011H163.451C164.075 75.1011 164.6 75.2149 165.026 75.4424C165.46 75.6699 165.784 75.9775 165.997 76.3652C166.21 76.7528 166.317 77.1952 166.317 77.6924C166.317 78.2992 166.151 78.8343 165.82 79.2978C165.496 79.7612 165.007 80.0688 164.351 80.2205L166.423 83.9115H165.133ZM161.865 79.3862H163.451C164.036 79.3862 164.474 79.2346 164.766 78.9312C165.058 78.6194 165.204 78.2065 165.204 77.6924C165.204 77.1699 165.058 76.7654 164.766 76.4789C164.482 76.1924 164.043 76.0492 163.451 76.0492H161.865V79.3862Z",
  stroke: "#1F1A17",
  strokeWidth: 0.5
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  id: "logoRail",
  d: "M176.227 75.1011V76.0365H173.978V83.9115H172.9V76.0365H170.639V75.1011H176.227Z",
  stroke: "#1F1A17",
  strokeWidth: 0.5
});

var _ref8 = /*#__PURE__*/React.createElement("path", {
  id: "logoRail",
  d: "M181.295 84C180.53 84 179.831 83.8104 179.2 83.4312C178.568 83.0435 178.067 82.5084 177.696 81.8258C177.333 81.1348 177.151 80.3596 177.151 79.5C177.151 78.6404 177.333 77.8694 177.696 77.1868C178.067 76.4958 178.568 75.9607 179.2 75.5815C179.831 75.1938 180.53 75 181.295 75C182.069 75 182.772 75.1938 183.403 75.5815C184.035 75.9607 184.532 76.4916 184.895 77.1742C185.258 77.8567 185.44 78.632 185.44 79.5C185.44 80.368 185.258 81.1433 184.895 81.8258C184.532 82.5084 184.035 83.0435 183.403 83.4312C182.772 83.8104 182.069 84 181.295 84ZM181.295 83.0014C181.872 83.0014 182.389 82.8581 182.847 82.5716C183.312 82.2851 183.675 81.8764 183.936 81.3455C184.204 80.8146 184.338 80.1994 184.338 79.5C184.338 78.7921 184.204 78.177 183.936 77.6545C183.675 77.1236 183.316 76.7149 182.858 76.4284C182.401 76.1419 181.88 75.9986 181.295 75.9986C180.711 75.9986 180.19 76.1419 179.732 76.4284C179.275 76.7149 178.911 77.1236 178.643 77.6545C178.383 78.177 178.252 78.7921 178.252 79.5C178.252 80.1994 178.383 80.8146 178.643 81.3455C178.911 81.8764 179.275 82.2851 179.732 82.5716C180.198 82.8581 180.719 83.0014 181.295 83.0014Z",
  stroke: "#1F1A17",
  strokeWidth: 0.5
});

var _ref9 = /*#__PURE__*/React.createElement("path", {
  id: "logoRail",
  d: "M195.536 77.6798C195.536 78.4129 195.3 79.0239 194.826 79.5126C194.36 79.993 193.646 80.2331 192.683 80.2331H191.096V83.9115H190.019V75.1011H192.683C193.614 75.1011 194.321 75.3413 194.802 75.8216C195.292 76.302 195.536 76.9213 195.536 77.6798ZM192.683 79.2851C193.283 79.2851 193.725 79.1461 194.009 78.868C194.293 78.5899 194.435 78.1938 194.435 77.6798C194.435 76.5927 193.851 76.0492 192.683 76.0492H191.096V79.2851H192.683Z",
  stroke: "#1F1A17",
  strokeWidth: 0.5
});

var _ref10 = /*#__PURE__*/React.createElement("path", {
  id: "logoRail",
  d: "M197.953 76.0365V78.9817H200.961V79.9298H197.953V82.9635H201.316V83.9115H196.876V75.0885H201.316V76.0365H197.953Z",
  stroke: "#1F1A17",
  strokeWidth: 0.5
});

var _ref11 = /*#__PURE__*/React.createElement("path", {
  id: "logoRail",
  d: "M207.292 83.9115L205.326 80.309H204.024V83.9115H202.946V75.1011H205.61C206.234 75.1011 206.759 75.2149 207.185 75.4424C207.619 75.6699 207.943 75.9775 208.156 76.3652C208.369 76.7528 208.476 77.1952 208.476 77.6924C208.476 78.2992 208.31 78.8343 207.979 79.2978C207.655 79.7612 207.165 80.0688 206.51 80.2205L208.582 83.9115H207.292ZM204.024 79.3862H205.61C206.195 79.3862 206.633 79.2346 206.925 78.9312C207.217 78.6194 207.363 78.2065 207.363 77.6924C207.363 77.1699 207.217 76.7654 206.925 76.4789C206.641 76.1924 206.202 76.0492 205.61 76.0492H204.024V79.3862Z",
  stroke: "#1F1A17",
  strokeWidth: 0.5
});

var _ref12 = /*#__PURE__*/React.createElement("path", {
  id: "logoRail",
  d: "M214.815 75.1011V76.0365H211.228V79.007H214.14V79.9424H211.228V83.9115H210.15V75.1011H214.815Z",
  stroke: "#1F1A17",
  strokeWidth: 0.5
});

var _ref13 = /*#__PURE__*/React.createElement("path", {
  id: "logoRail",
  d: "M219.858 84C219.093 84 218.394 83.8104 217.762 83.4312C217.131 83.0435 216.63 82.5084 216.259 81.8258C215.896 81.1348 215.714 80.3596 215.714 79.5C215.714 78.6404 215.896 77.8694 216.259 77.1868C216.63 76.4958 217.131 75.9607 217.762 75.5815C218.394 75.1938 219.093 75 219.858 75C220.632 75 221.334 75.1938 221.966 75.5815C222.597 75.9607 223.095 76.4916 223.458 77.1742C223.821 77.8567 224.002 78.632 224.002 79.5C224.002 80.368 223.821 81.1433 223.458 81.8258C223.095 82.5084 222.597 83.0435 221.966 83.4312C221.334 83.8104 220.632 84 219.858 84ZM219.858 83.0014C220.435 83.0014 220.952 82.8581 221.409 82.5716C221.875 82.2851 222.238 81.8764 222.499 81.3455C222.767 80.8146 222.901 80.1994 222.901 79.5C222.901 78.7921 222.767 78.177 222.499 77.6545C222.238 77.1236 221.879 76.7149 221.421 76.4284C220.963 76.1419 220.442 75.9986 219.858 75.9986C219.274 75.9986 218.753 76.1419 218.295 76.4284C217.837 76.7149 217.474 77.1236 217.206 77.6545C216.945 78.177 216.815 78.7921 216.815 79.5C216.815 80.1994 216.945 80.8146 217.206 81.3455C217.474 81.8764 217.837 82.2851 218.295 82.5716C218.761 82.8581 219.282 83.0014 219.858 83.0014Z",
  stroke: "#1F1A17",
  strokeWidth: 0.5
});

var _ref14 = /*#__PURE__*/React.createElement("path", {
  id: "logoRail",
  d: "M229.77 83.9115L227.805 80.309H226.502V83.9115H225.425V75.1011H228.089C228.713 75.1011 229.238 75.2149 229.664 75.4424C230.098 75.6699 230.422 75.9775 230.635 76.3652C230.848 76.7528 230.954 77.1952 230.954 77.6924C230.954 78.2992 230.789 78.8343 230.457 79.2978C230.134 79.7612 229.644 80.0688 228.989 80.2205L231.061 83.9115H229.77ZM226.502 79.3862H228.089C228.673 79.3862 229.111 79.2346 229.403 78.9312C229.695 78.6194 229.841 78.2065 229.841 77.6924C229.841 77.1699 229.695 76.7654 229.403 76.4789C229.119 76.1924 228.681 76.0492 228.089 76.0492H226.502V79.3862Z",
  stroke: "#1F1A17",
  strokeWidth: 0.5
});

var _ref15 = /*#__PURE__*/React.createElement("path", {
  id: "logoRail",
  d: "M241 75.1643V83.9115H239.923V77.389L237.199 83.9115H236.441L233.706 77.3764V83.9115H232.629V75.1643H233.789L236.82 82.3947L239.851 75.1643H241Z",
  stroke: "#1F1A17",
  strokeWidth: 0.5
});

var _ref16 = /*#__PURE__*/React.createElement("path", {
  id: "logoEp",
  d: "M80.064 40.096L80.0641 51.28H92.2561V54.88H80.0641V66.4H93.6961V70H75.6961V36.496H93.6961L93.696 40.096H80.064Z",
  stroke: "#913A38",
  strokeWidth: 2
});

var _ref17 = /*#__PURE__*/React.createElement("path", {
  id: "logoEp",
  d: "M122.913 46.336C122.913 49.12 121.953 51.44 120.033 53.296C118.145 55.12 115.249 56.032 111.345 56.032H104.913V70H100.545V36.544H111.345C115.121 36.544 117.985 37.456 119.937 39.28C121.921 41.104 122.913 43.456 122.913 46.336ZM111.345 52.432C113.777 52.432 115.569 51.904 116.721 50.848C117.873 49.792 118.449 48.288 118.449 46.336C118.449 42.208 116.081 40.144 111.345 40.144H104.913V52.432H111.345Z",
  stroke: "#913A38",
  strokeWidth: 2
});

var _ref18 = /*#__PURE__*/React.createElement("path", {
  id: "logoRail",
  d: "M146.312 70L138.344 56.32H133.064V70H128.696V36.544H139.496C142.024 36.544 144.152 36.976 145.88 37.84C147.64 38.704 148.952 39.872 149.816 41.344C150.68 42.816 151.112 44.496 151.112 46.384C151.112 48.688 150.44 50.72 149.096 52.48C147.784 54.24 145.8 55.408 143.144 55.984L151.544 70H146.312ZM133.064 52.816H139.496C141.864 52.816 143.64 52.24 144.824 51.088C146.008 49.904 146.6 48.336 146.6 46.384C146.6 44.4 146.008 42.864 144.824 41.776C143.672 40.688 141.896 40.144 139.496 40.144H133.064V52.816Z",
  stroke: "#1F1A17",
  strokeWidth: 2
});

var _ref19 = /*#__PURE__*/React.createElement("path", {
  id: "logoRail",
  d: "M184.875 62.56H170.283L167.595 70H162.987L175.083 36.736H180.123L192.171 70H187.563L184.875 62.56ZM183.627 59.008L177.579 42.112L171.531 59.008H183.627Z",
  stroke: "#1F1A17",
  strokeWidth: 2
});

var _ref20 = /*#__PURE__*/React.createElement("path", {
  id: "logoRail",
  d: "M209.011 36.544V70H204.643V36.544H209.011Z",
  stroke: "#1F1A17",
  strokeWidth: 2
});

var _ref21 = /*#__PURE__*/React.createElement("path", {
  id: "logoRail",
  d: "M228.023 66.448H239.735V70H223.655V36.544H228.023V66.448Z",
  stroke: "#1F1A17",
  strokeWidth: 2
});

var _ref22 = /*#__PURE__*/React.createElement("ellipse", {
  id: "ellipseEpLogo",
  cx: 111.267,
  cy: 13.4474,
  rx: 1.36588,
  ry: 1.26862,
  fill: "#913A38"
});

var _ref23 = /*#__PURE__*/React.createElement("ellipse", {
  id: "ellipseEpLogo",
  cx: 99.0787,
  cy: 4.05957,
  rx: 1.36588,
  ry: 1.26862,
  fill: "#913A38"
});

var _ref24 = /*#__PURE__*/React.createElement("ellipse", {
  id: "ellipseEpLogo",
  cx: 99.0787,
  cy: 14.2085,
  rx: 2.20642,
  ry: 2.02979,
  fill: "#913A38"
});

var _ref25 = /*#__PURE__*/React.createElement("ellipse", {
  id: "ellipseEpLogo",
  cx: 87.5213,
  cy: 2.28351,
  rx: 2.20642,
  ry: 2.02979,
  fill: "#913A38"
});

var _ref26 = /*#__PURE__*/React.createElement("ellipse", {
  id: "ellipseEpLogo",
  cx: 83.2135,
  cy: 17.5069,
  rx: 2.94189,
  ry: 2.79096,
  fill: "#913A38"
});

var _ref27 = /*#__PURE__*/React.createElement("ellipse", {
  id: "ellipseEpLogo",
  cx: 70.8156,
  cy: 4.05958,
  rx: 2.94189,
  ry: 2.79096,
  fill: "#913A38"
});

var _ref28 = /*#__PURE__*/React.createElement("ellipse", {
  id: "ellipseEpLogo",
  cx: 62.9355,
  cy: 26.8947,
  rx: 4.93818,
  ry: 3.80586,
  fill: "#913A38"
});

var _ref29 = /*#__PURE__*/React.createElement("ellipse", {
  id: "ellipseEpLogo",
  cx: 49.2767,
  cy: 11.1638,
  rx: 4.93818,
  ry: 3.80586,
  fill: "#913A38"
});

var _ref30 = /*#__PURE__*/React.createElement("ellipse", {
  id: "ellipseEpLogo",
  cx: 41.1865,
  cy: 47.827,
  rx: 6.51419,
  ry: 5.20134,
  fill: "#913A38"
});

var _ref31 = /*#__PURE__*/React.createElement("ellipse", {
  id: "ellipseEpLogo",
  cx: 22.9047,
  cy: 27.0216,
  rx: 6.51419,
  ry: 5.20134,
  fill: "#913A38"
});

var _ref32 = /*#__PURE__*/React.createElement("ellipse", {
  id: "ellipseEpLogo",
  cx: 80.2716,
  cy: 2.79096,
  rx: 2.94189,
  ry: 2.79096,
  fill: "#1F1A17"
});

var _ref33 = /*#__PURE__*/React.createElement("ellipse", {
  id: "ellipseEpLogo",
  cx: 73.8625,
  cy: 21.0591,
  rx: 3.8875,
  ry: 3.55213,
  fill: "#1F1A17"
});

var _ref34 = /*#__PURE__*/React.createElement("ellipse", {
  id: "ellipseEpLogo",
  cx: 61.0443,
  cy: 6.34309,
  rx: 3.8875,
  ry: 3.55213,
  fill: "#1F1A17"
});

var _ref35 = /*#__PURE__*/React.createElement("ellipse", {
  id: "ellipseEpLogo",
  cx: 35.6179,
  cy: 17.8875,
  rx: 5.56858,
  ry: 4.44017,
  fill: "#1F1A17"
});

var _ref36 = /*#__PURE__*/React.createElement("ellipse", {
  id: "ellipseEpLogo",
  cx: 52.0085,
  cy: 36.1557,
  rx: 5.56858,
  ry: 4.44017,
  fill: "#1F1A17"
});

var _ref37 = /*#__PURE__*/React.createElement("ellipse", {
  id: "ellipseEpLogo",
  cx: 30.9949,
  cy: 63.6847,
  rx: 9.77129,
  ry: 8.37289,
  fill: "#1F1A17"
});

var _ref38 = /*#__PURE__*/React.createElement("ellipse", {
  id: "ellipseEpLogo",
  cx: 9.77129,
  cy: 43.133,
  rx: 9.77129,
  ry: 8.37289,
  fill: "#1F1A17"
});

var _ref39 = /*#__PURE__*/React.createElement("ellipse", {
  id: "ellipseEpLogo",
  cx: 92.0392,
  cy: 15.2234,
  rx: 2.52162,
  ry: 2.02979,
  fill: "#1F1A17"
});

var _ref40 = /*#__PURE__*/React.createElement("ellipse", {
  id: "ellipseEpLogo",
  cx: 93.3,
  cy: 2.91782,
  rx: 1.47095,
  ry: 1.39548,
  fill: "#1F1A17"
});

var _ref41 = /*#__PURE__*/React.createElement("ellipse", {
  id: "ellipseEpLogo",
  cx: 105.488,
  cy: 13.5742,
  rx: 1.47095,
  ry: 1.39548,
  fill: "#1F1A17"
});

var _ref42 = /*#__PURE__*/React.createElement("ellipse", {
  id: "ellipseEpLogo",
  rx: 1.19174,
  ry: 1.10687,
  transform: "matrix(-0.999983 0.0058445 -0.00400891 -0.999992 225.196 104.596)",
  fill: "#913A38"
});

var _ref43 = /*#__PURE__*/React.createElement("ellipse", {
  id: "ellipseEpLogo",
  rx: 1.19174,
  ry: 1.10687,
  transform: "matrix(-0.999983 0.0058445 -0.00400891 -0.999992 235.863 112.725)",
  fill: "#913A38"
});

var _ref44 = /*#__PURE__*/React.createElement("ellipse", {
  id: "ellipseEpLogo",
  rx: 1.92511,
  ry: 1.77099,
  transform: "matrix(-0.999983 0.0058445 -0.00400891 -0.999992 235.827 103.87)",
  fill: "#913A38"
});

var _ref45 = /*#__PURE__*/React.createElement("ellipse", {
  id: "ellipseEpLogo",
  rx: 1.92511,
  ry: 1.77099,
  transform: "matrix(-0.999983 0.0058445 -0.00400891 -0.999992 245.953 114.215)",
  fill: "#913A38"
});

var _ref46 = /*#__PURE__*/React.createElement("ellipse", {
  id: "ellipseEpLogo",
  rx: 2.56682,
  ry: 2.43511,
  transform: "matrix(-0.999983 0.0058445 -0.00400891 -0.999992 249.658 100.911)",
  fill: "#913A38"
});

var _ref47 = /*#__PURE__*/React.createElement("ellipse", {
  id: "ellipseEpLogo",
  rx: 2.56682,
  ry: 2.43511,
  transform: "matrix(-0.999983 0.0058445 -0.00400891 -0.999992 260.522 112.581)",
  fill: "#913A38"
});

var _ref48 = /*#__PURE__*/React.createElement("ellipse", {
  id: "ellipseEpLogo",
  rx: 4.30859,
  ry: 3.32061,
  transform: "matrix(-0.999983 0.0058445 -0.00400891 -0.999992 267.318 92.6169)",
  fill: "#913A38"
});

var _ref49 = /*#__PURE__*/React.createElement("ellipse", {
  id: "ellipseEpLogo",
  rx: 4.30859,
  ry: 3.32061,
  transform: "matrix(-0.999983 0.0058445 -0.00400891 -0.999992 279.29 106.272)",
  fill: "#913A38"
});

var _ref50 = /*#__PURE__*/React.createElement("ellipse", {
  id: "ellipseEpLogo",
  rx: 5.68367,
  ry: 4.53816,
  transform: "matrix(-0.999983 0.0058445 -0.00400891 -0.999992 286.22 74.2428)",
  fill: "#913A38"
});

var _ref51 = /*#__PURE__*/React.createElement("ellipse", {
  id: "ellipseEpLogo",
  rx: 5.68367,
  ry: 4.53816,
  transform: "matrix(-0.999983 0.0058445 -0.00400891 -0.999992 302.244 92.3021)",
  fill: "#913A38"
});

var _ref52 = /*#__PURE__*/React.createElement("ellipse", {
  id: "ellipseEpLogo",
  rx: 2.56682,
  ry: 2.43511,
  transform: "matrix(-0.999983 0.0058445 -0.00400891 -0.999992 252.276 113.736)",
  fill: "#1F1A17"
});

var _ref53 = /*#__PURE__*/React.createElement("ellipse", {
  id: "ellipseEpLogo",
  rx: 3.39187,
  ry: 3.09923,
  transform: "matrix(-0.999983 0.0058445 -0.00400891 -0.999992 257.804 97.7642)",
  fill: "#1F1A17"
});

var _ref54 = /*#__PURE__*/React.createElement("ellipse", {
  id: "ellipseEpLogo",
  rx: 3.39187,
  ry: 3.09923,
  transform: "matrix(-0.999983 0.0058445 -0.00400891 -0.999992 269.04 110.538)",
  fill: "#1F1A17"
});

var _ref55 = /*#__PURE__*/React.createElement("ellipse", {
  id: "ellipseEpLogo",
  rx: 4.85862,
  ry: 3.87404,
  transform: "matrix(-0.999983 0.0058445 -0.00400891 -0.999992 291.183 100.336)",
  fill: "#1F1A17"
});

var _ref56 = /*#__PURE__*/React.createElement("ellipse", {
  id: "ellipseEpLogo",
  rx: 4.85862,
  ry: 3.87404,
  transform: "matrix(-0.999983 0.0058445 -0.00400891 -0.999992 276.819 84.4811)",
  fill: "#1F1A17"
});

var _ref57 = /*#__PURE__*/React.createElement("ellipse", {
  id: "ellipseEpLogo",
  rx: 8.52551,
  ry: 7.30533,
  transform: "matrix(-0.999983 0.0058445 -0.00400891 -0.999992 295.057 60.3551)",
  fill: "#1F1A17"
});

var _ref58 = /*#__PURE__*/React.createElement("ellipse", {
  id: "ellipseEpLogo",
  rx: 8.52551,
  ry: 7.30533,
  transform: "matrix(-0.999983 0.0058445 -0.00400891 -0.999992 313.646 78.178)",
  fill: "#1F1A17"
});

var _ref59 = /*#__PURE__*/React.createElement("ellipse", {
  id: "ellipseEpLogo",
  rx: 2.20013,
  ry: 1.77099,
  transform: "matrix(-0.999983 0.0058445 -0.00400891 -0.999992 241.966 102.948)",
  fill: "#1F1A17"
});

var _ref60 = /*#__PURE__*/React.createElement("ellipse", {
  id: "ellipseEpLogo",
  rx: 1.28341,
  ry: 1.21756,
  transform: "matrix(-0.999983 0.0058445 -0.00400891 -0.999992 240.909 113.691)",
  fill: "#1F1A17"
});

var _ref61 = /*#__PURE__*/React.createElement("ellipse", {
  id: "ellipseEpLogo",
  rx: 1.28341,
  ry: 1.21756,
  transform: "matrix(-0.999983 0.0058445 -0.00400891 -0.999992 230.238 104.456)",
  fill: "#1F1A17"
});

var SvgMainLogo = function SvgMainLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "logo",
    viewBox: "0 0 323 117",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7, _ref8, _ref9, _ref10, _ref11, _ref12, _ref13, _ref14, _ref15, _ref16, _ref17, _ref18, _ref19, _ref20, _ref21, _ref22, _ref23, _ref24, _ref25, _ref26, _ref27, _ref28, _ref29, _ref30, _ref31, _ref32, _ref33, _ref34, _ref35, _ref36, _ref37, _ref38, _ref39, _ref40, _ref41, _ref42, _ref43, _ref44, _ref45, _ref46, _ref47, _ref48, _ref49, _ref50, _ref51, _ref52, _ref53, _ref54, _ref55, _ref56, _ref57, _ref58, _ref59, _ref60, _ref61);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgMainLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/mainLogo.052639b5.svg";
export { ForwardRef as ReactComponent };